/* eslint-disable no-console */
import _get from 'lodash/get';
import Store from 'lightningjs-redux';
import { getTimeFormat } from '@bedrock-rdk/utils';
import { CommonBridge } from './bridges/commonBridge';
import { createAdRenderers } from '../player.utils';
import {
  ADS_COUNTDOWN_DEFAULT_TOTAL_DURATION,
  AD_ANALYTICS_TYPES,
  BRIDGE_AD_OCEAN,
  MIRRORED_AD_EVENTS,
} from './ads.constants';
import { sendEvent } from '../../../logic/analytics/analytics.utils';

export const BRIDGES = {
  [BRIDGE_AD_OCEAN]: CommonBridge,
};

export const bridgeClassByProviderId = adsProviderId => BRIDGES[adsProviderId] || CommonBridge;

/**
 * @returns {Object} ad bridge handlers of the events which are only mirrored, see MIRRORED_AD_EVENTS
 */
export const createMirroredAdEventHandlers = () =>
  Object.entries(MIRRORED_AD_EVENTS).reduce((handlers, [name, { createAction, analyticsKey }]) => {
    handlers[name] = (...args) => {
      console.log(`[player.ads.adapter] ${name}`, ...args);

      if (createAction) {
        Store.dispatch(createAction(...args));
      }

      if (analyticsKey) {
        sendEvent({ key: analyticsKey });
      }
    };

    return handlers;
  }, {});

export const createRenderers = prefix => {
  const { container, video } = createAdRenderers(prefix);

  container.className = 'ads-container';

  const companion = document.createElement('div');
  // TODO: clarify companion container styling
  companion.style.cssText = 'position: fixed; top: 32px; right: 32px; width: 300px; height: 250px; overflow: hidden;';
  container.appendChild(companion);

  return { companion, container, video };
};

export const adExitAnalyticsEvent = type => {
  const analyticsKey = _get(AD_ANALYTICS_TYPES.back, type, null);

  if (analyticsKey) sendEvent({ key: analyticsKey });
};

export const getAdsDurationInSeconds = adBreak => {
  if (!adBreak || !Array.isArray(adBreak.ads)) {
    return 0;
  }

  return adBreak.ads
    .map(ad => {
      const playableAds = (ad.creatives || []).filter(({ assets }) => assets.length > 0);
      if (!playableAds.length) {
        return 0;
      }
      const adDuration = playableAds[0].duration;

      return adDuration || ADS_COUNTDOWN_DEFAULT_TOTAL_DURATION;
    })
    .reduce((result, duration) => result + duration, 0);
};

export const updateCountdown = (view, elapsed, total, skipAnimation = false) => {
  view.body = getTimeFormat(Math.floor(total - elapsed));

  const value = 1.0 - Math.min(Math.max(total ? elapsed / total : 0, 0), 1);
  if (skipAnimation || (!view.progress && value)) {
    view.progress = value;
  } else {
    view.setSmooth('progress', value, {
      duration: 0.35,
    });
  }
};

export const updateQueryParams = config => {
  const queryParams = config.queryParams || {};
  const apiframeworks = _get(config, 'brParams.vastmacro.APIFRAMEWORKS', '');

  return { ...queryParams, apiframeworks };
};
